export const ADD_PERM_NOTIFICATION = "ADD PERM NOTIFICATION";
export const UPDATE_PERM_NOTIFICATION = "UPDATE PERM NOTIFICATION";
export const REMOVE_PERM_NOTIFICATION = "REMOVE PERM NOTIFICATION";
